import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { SET_UTM_DATA } from '../../redux/actions/types';

const UtmData = () => {

    const [searchParams , setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    useEffect(() => {
        const utmSource = searchParams?.get("utm_source");
        const utmMedium = searchParams?.get("utm_medium");
        const utmCampaign = searchParams?.get("utm_campaign");
        const utmContent = searchParams?.get("utm_content");
        const utmTerm = searchParams?.get("utm_term");


        dispatch({type : SET_UTM_DATA , payload: { utmSource , utmMedium , utmCampaign , utmContent , utmTerm }});
    }, [])
  return (
    <div>
      
    </div>
  )
}

export default UtmData
